/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BookBean', 'model/UserBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BookBean'), require('./UserBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesProductionappspotcom) {
      root.BelfastpilatesProductionappspotcom = {};
    }
    root.BelfastpilatesProductionappspotcom.SetBean = factory(root.BelfastpilatesProductionappspotcom.ApiClient, root.BelfastpilatesProductionappspotcom.BookBean, root.BelfastpilatesProductionappspotcom.UserBean);
  }
}(this, function(ApiClient, BookBean, UserBean) {
  'use strict';




  /**
   * The SetBean model module.
   * @module model/SetBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>SetBean</code>.
   * @alias module:model/SetBean
   * @class
   */
  var exports = function() {
    var _this = this;










































  };

  /**
   * Constructs a <code>SetBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SetBean} obj Optional instance to populate.
   * @return {module:model/SetBean} The populated <code>SetBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('bookIdentifier')) {
        obj['bookIdentifier'] = ApiClient.convertToType(data['bookIdentifier'], 'String');
      }
      if (data.hasOwnProperty('bookList')) {
        obj['bookList'] = ApiClient.convertToType(data['bookList'], [BookBean]);
      }
      if (data.hasOwnProperty('bookedUserDetails')) {
        obj['bookedUserDetails'] = ApiClient.convertToType(data['bookedUserDetails'], [UserBean]);
      }
      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('completeBookedListUserDetails')) {
        obj['completeBookedListUserDetails'] = ApiClient.convertToType(data['completeBookedListUserDetails'], [BookBean]);
      }
      if (data.hasOwnProperty('cost')) {
        obj['cost'] = ApiClient.convertToType(data['cost'], 'String');
      }
      if (data.hasOwnProperty('costBeforeFee')) {
        obj['costBeforeFee'] = ApiClient.convertToType(data['costBeforeFee'], 'String');
      }
      if (data.hasOwnProperty('costBeforeFeeToDisplay')) {
        obj['costBeforeFeeToDisplay'] = ApiClient.convertToType(data['costBeforeFeeToDisplay'], 'String');
      }
      if (data.hasOwnProperty('costToDisplay')) {
        obj['costToDisplay'] = ApiClient.convertToType(data['costToDisplay'], 'String');
      }
      if (data.hasOwnProperty('currentNumberOfUsers')) {
        obj['currentNumberOfUsers'] = ApiClient.convertToType(data['currentNumberOfUsers'], 'Number');
      }
      if (data.hasOwnProperty('dayOfWeek')) {
        obj['dayOfWeek'] = ApiClient.convertToType(data['dayOfWeek'], ['String']);
      }
      if (data.hasOwnProperty('endDate')) {
        obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
      }
      if (data.hasOwnProperty('endDateDisplayString')) {
        obj['endDateDisplayString'] = ApiClient.convertToType(data['endDateDisplayString'], 'String');
      }
      if (data.hasOwnProperty('fridayTime')) {
        obj['fridayTime'] = ApiClient.convertToType(data['fridayTime'], ['String']);
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('instructorDetails')) {
        obj['instructorDetails'] = ApiClient.convertToType(data['instructorDetails'], [UserBean]);
      }
      if (data.hasOwnProperty('instructorIds')) {
        obj['instructorIds'] = ApiClient.convertToType(data['instructorIds'], ['String']);
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('level')) {
        obj['level'] = ApiClient.convertToType(data['level'], 'String');
      }
      if (data.hasOwnProperty('maxSpace')) {
        obj['maxSpace'] = ApiClient.convertToType(data['maxSpace'], 'Number');
      }
      if (data.hasOwnProperty('mondayTime')) {
        obj['mondayTime'] = ApiClient.convertToType(data['mondayTime'], ['String']);
      }
      if (data.hasOwnProperty('noOfBooks')) {
        obj['noOfBooks'] = ApiClient.convertToType(data['noOfBooks'], 'Number');
      }
      if (data.hasOwnProperty('roomId')) {
        obj['roomId'] = ApiClient.convertToType(data['roomId'], 'String');
      }
      if (data.hasOwnProperty('saturdayTime')) {
        obj['saturdayTime'] = ApiClient.convertToType(data['saturdayTime'], ['String']);
      }
      if (data.hasOwnProperty('serviceFee')) {
        obj['serviceFee'] = ApiClient.convertToType(data['serviceFee'], 'Number');
      }
      if (data.hasOwnProperty('serviceFeeToDisplay')) {
        obj['serviceFeeToDisplay'] = ApiClient.convertToType(data['serviceFeeToDisplay'], 'String');
      }
      if (data.hasOwnProperty('serviceId')) {
        obj['serviceId'] = ApiClient.convertToType(data['serviceId'], 'String');
      }
      if (data.hasOwnProperty('startDate')) {
        obj['startDate'] = ApiClient.convertToType(data['startDate'], 'Date');
      }
      if (data.hasOwnProperty('startDateDisplayString')) {
        obj['startDateDisplayString'] = ApiClient.convertToType(data['startDateDisplayString'], 'String');
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String');
      }
      if (data.hasOwnProperty('storeCost')) {
        obj['storeCost'] = ApiClient.convertToType(data['storeCost'], 'String');
      }
      if (data.hasOwnProperty('sundayTime')) {
        obj['sundayTime'] = ApiClient.convertToType(data['sundayTime'], ['String']);
      }
      if (data.hasOwnProperty('swapPaymentRequired')) {
        obj['swapPaymentRequired'] = ApiClient.convertToType(data['swapPaymentRequired'], 'Boolean');
      }
      if (data.hasOwnProperty('thursdayTime')) {
        obj['thursdayTime'] = ApiClient.convertToType(data['thursdayTime'], ['String']);
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('tuesdayTime')) {
        obj['tuesdayTime'] = ApiClient.convertToType(data['tuesdayTime'], ['String']);
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
      if (data.hasOwnProperty('voucherDiscount')) {
        obj['voucherDiscount'] = ApiClient.convertToType(data['voucherDiscount'], 'String');
      }
      if (data.hasOwnProperty('voucherMessage')) {
        obj['voucherMessage'] = ApiClient.convertToType(data['voucherMessage'], 'String');
      }
      if (data.hasOwnProperty('voucherName')) {
        obj['voucherName'] = ApiClient.convertToType(data['voucherName'], 'String');
      }
      if (data.hasOwnProperty('wednesdayTime')) {
        obj['wednesdayTime'] = ApiClient.convertToType(data['wednesdayTime'], ['String']);
      }
    }
    return obj;
  }

  /**
   * @member {String} bookIdentifier
   */
  exports.prototype['bookIdentifier'] = undefined;
  /**
   * @member {Array.<module:model/BookBean>} bookList
   */
  exports.prototype['bookList'] = undefined;
  /**
   * @member {Array.<module:model/UserBean>} bookedUserDetails
   */
  exports.prototype['bookedUserDetails'] = undefined;
  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {Array.<module:model/BookBean>} completeBookedListUserDetails
   */
  exports.prototype['completeBookedListUserDetails'] = undefined;
  /**
   * @member {String} cost
   */
  exports.prototype['cost'] = undefined;
  /**
   * @member {String} costBeforeFee
   */
  exports.prototype['costBeforeFee'] = undefined;
  /**
   * @member {String} costBeforeFeeToDisplay
   */
  exports.prototype['costBeforeFeeToDisplay'] = undefined;
  /**
   * @member {String} costToDisplay
   */
  exports.prototype['costToDisplay'] = undefined;
  /**
   * @member {Number} currentNumberOfUsers
   */
  exports.prototype['currentNumberOfUsers'] = undefined;
  /**
   * @member {Array.<String>} dayOfWeek
   */
  exports.prototype['dayOfWeek'] = undefined;
  /**
   * @member {Date} endDate
   */
  exports.prototype['endDate'] = undefined;
  /**
   * @member {String} endDateDisplayString
   */
  exports.prototype['endDateDisplayString'] = undefined;
  /**
   * @member {Array.<String>} fridayTime
   */
  exports.prototype['fridayTime'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {Array.<module:model/UserBean>} instructorDetails
   */
  exports.prototype['instructorDetails'] = undefined;
  /**
   * @member {Array.<String>} instructorIds
   */
  exports.prototype['instructorIds'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {String} level
   */
  exports.prototype['level'] = undefined;
  /**
   * @member {Number} maxSpace
   */
  exports.prototype['maxSpace'] = undefined;
  /**
   * @member {Array.<String>} mondayTime
   */
  exports.prototype['mondayTime'] = undefined;
  /**
   * @member {Number} noOfBooks
   */
  exports.prototype['noOfBooks'] = undefined;
  /**
   * @member {String} roomId
   */
  exports.prototype['roomId'] = undefined;
  /**
   * @member {Array.<String>} saturdayTime
   */
  exports.prototype['saturdayTime'] = undefined;
  /**
   * @member {Number} serviceFee
   */
  exports.prototype['serviceFee'] = undefined;
  /**
   * @member {String} serviceFeeToDisplay
   */
  exports.prototype['serviceFeeToDisplay'] = undefined;
  /**
   * @member {String} serviceId
   */
  exports.prototype['serviceId'] = undefined;
  /**
   * @member {Date} startDate
   */
  exports.prototype['startDate'] = undefined;
  /**
   * @member {String} startDateDisplayString
   */
  exports.prototype['startDateDisplayString'] = undefined;
  /**
   * @member {String} status
   */
  exports.prototype['status'] = undefined;
  /**
   * @member {String} storeCost
   */
  exports.prototype['storeCost'] = undefined;
  /**
   * @member {Array.<String>} sundayTime
   */
  exports.prototype['sundayTime'] = undefined;
  /**
   * @member {Boolean} swapPaymentRequired
   */
  exports.prototype['swapPaymentRequired'] = undefined;
  /**
   * @member {Array.<String>} thursdayTime
   */
  exports.prototype['thursdayTime'] = undefined;
  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * @member {Array.<String>} tuesdayTime
   */
  exports.prototype['tuesdayTime'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * @member {String} voucherDiscount
   */
  exports.prototype['voucherDiscount'] = undefined;
  /**
   * @member {String} voucherMessage
   */
  exports.prototype['voucherMessage'] = undefined;
  /**
   * @member {String} voucherName
   */
  exports.prototype['voucherName'] = undefined;
  /**
   * @member {Array.<String>} wednesdayTime
   */
  exports.prototype['wednesdayTime'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/SetBean.js